export default __webpack_public_path__ + "static/media/close-persons.b4d6de4a.svg";